import { t } from "@/i18n-js/instance";
import { Icon } from "../../shared/Icon";
import HelpInputArea from "../components/common/HelpInputArea";

const ConversationPage = () => (
  <div className="hide-scrollbar flex h-full flex-col overflow-y-auto">
    <div className="flex-1" />
    <div className="sticky bottom-0 z-10 p-4">
      <HelpInputArea
        onSubmit={() => {}}
        placeholder={t(
          "support_widget_v2.conversation_page.help_input_placeholder",
        )}
      />
    </div>
    <div className="text-tertiary sticky bottom-0 flex justify-center rounded-lg px-4 pb-4 text-xs">
      {t("support_widget_v2.conversation_page.footer_message")}
      <Icon type="info" size={14} />
    </div>
  </div>
);

export default ConversationPage;
